import { generatePath } from 'react-router';
import { getRoute } from './get-route';
import { encodeQueryString } from  '../../../utilities/listing';
import { omit } from 'lodash';

const parseQueryParamData = (params, queryParamKey) => {
	if(params && params[queryParamKey]) {
		const encodedQuery = encodeQueryString({ query: params[queryParamKey]});

		if(encodedQuery.length > 0) {
			return {
				...params,
				[queryParamKey]: encodedQuery
			}
		}
		else {
			return omit(params, [queryParamKey]);
		}
	}
	
	return params;
}

export const getRoutePath = ({ routes, routeKey, params = {}, parseQueryParams, queryParamKey}) => {
	if(!routes) {
		return false;
	}
	const route = getRoute({ routes, routeKey });

	if(!route) {
		return false;
	}

	try {
		const routePath = generatePath(route.path, parseQueryParams ? parseQueryParamData(params, queryParamKey) : params);
		return routePath;
	}
	catch(e) {
		console.warn('Invalid parameters for route:', routeKey, params);
		return false
	}
}